// import _isString from 'lodash/isString';

export const isString = (value: any) => typeof value === 'string';
